import { render, staticRenderFns } from "./BarMultid.vue?vue&type=template&id=8bcc7a66&scoped=true"
import script from "./BarMultid.vue?vue&type=script&lang=js"
export * from "./BarMultid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcc7a66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bcc7a66')) {
      api.createRecord('8bcc7a66', component.options)
    } else {
      api.reload('8bcc7a66', component.options)
    }
    module.hot.accept("./BarMultid.vue?vue&type=template&id=8bcc7a66&scoped=true", function () {
      api.rerender('8bcc7a66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chart/BarMultid.vue"
export default component.exports